import { camelCase, kebabCase } from 'lodash-es';

import { JOBS, MAGAZIN_JOB_APPLICATION_TIPS_URL } from '@pflegia/ui/pflegia/constants/routes';

type RelatedJobTitle = {
  id: string;
  title: string;
};

type BuildJobListingSchemaUrlsProps = {
  jobsBaseUrl: string;
  relatedJobTitles: RelatedJobTitle[];
  locationFilterValue: string;
  relatedLocations: string[];
  jobPositionFilterValue: string;
};

export const buildJobListingSchemaUrls = ({
  jobsBaseUrl,
  relatedJobTitles,
  locationFilterValue,
  relatedLocations,
  jobPositionFilterValue,
}: BuildJobListingSchemaUrlsProps): Record<string, string | Record<string, string>> => ({
  magazinJobApplicationTips: MAGAZIN_JOB_APPLICATION_TIPS_URL,
  RelatedJobTitles: Object.fromEntries(
    relatedJobTitles.map(({ title }) => [
      title,
      locationFilterValue
        ? `${jobsBaseUrl}${JOBS}/${kebabCase(camelCase(title))}/${kebabCase(locationFilterValue)}`
        : `${jobsBaseUrl}${JOBS}/${kebabCase(camelCase(title))}`,
    ]),
  ),
  RelatedLocations: Object.fromEntries(
    relatedLocations.map(relatedLocation => [
      relatedLocation,
      jobPositionFilterValue
        ? `${jobsBaseUrl}${JOBS}/${kebabCase(camelCase(jobPositionFilterValue))}/${kebabCase(relatedLocation)}`
        : `${jobsBaseUrl}${JOBS}/${kebabCase(relatedLocation)}`,
    ]),
  ),
});
